/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



jQuery('.HorizontalList.HorizontalList--spacingExtraLoose').hover(function() {
  jQuery('.MegaMenu.MegaMenu--grid').attr('aria-hidden','true');
});

jQuery('.HorizontalList.HorizontalList--spacingExtraLoose .HorizontalList__Item:nth-of-type(2)').mouseleave(function() {
  jQuery('.MegaMenu.MegaMenu--grid').attr('aria-hidden','true');
});

jQuery('.scroll-link').on('click',function(e) {
	e.preventDefault();
	var offset = 200;
	var target = this.hash;
	if (jQuery(this).data('offset') != undefined) offset = jQuery(this).data('offset');
	jQuery('html, body').stop().animate({
		'scrollTop': jQuery(target).offset().top - offset
	}, 500, 'swing', function() {
		// window.location.hash = target;
	});
});





function _addMeToCart(e, el) {
e = e || window.event;
e.preventDefault();

let formData = {
'items': [
{
'id': el.dataset.variant_id,
'quantity': 1
}
]
};

fetch('/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify(formData)
})
.then((resp) => {
return resp.json();
})
.then((data) => {
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
bubbles: true
}));
})
.catch((err) => {
console.error('Error: ' + err);
})
}

$(document).on('click', '.lipscore-rating-review-link', function(e) {
  let reviewsTabIsOpen = $('.ls-tab-button').get(0).getAttribute('aria-expanded') === 'true';
  console.log(reviewsTabIsOpen);

  if (!reviewsTabIsOpen) {
    e.preventDefault();
    $('.ls-tab-button').get(0).click();
    setTimeout(() => {
      $('.lipscore-rating-review-link').get(0).click();
    }, 300);
  }
});


